import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { Button, Icon, Row } from 'antd';
import { Link } from 'react-router-dom';
import * as uuid from 'uuid';

import { FormatService } from 'src/core/services/format.service';
import { DataTableView, Column, ToolbarVisibility } from 'src/core/ui/data-table.view';
import { OptionsDialogView } from 'src/core/ui/options-dialog.view';
import { TextView } from 'src/core/ui/text.view';
import { DateView } from 'src/core/ui/date.view';
import { ClientGDPRSummaryDataService } from './client-gdpr.data';

interface ClientGDPRListViewProps extends ComponentViewProps<DataSet<ClientGDPRSummary>> {
	onItemEdit: (clientId?: number) => void;
	formatService: FormatService
}

@observer
export class ClientGDPRListView extends React.Component<ClientGDPRListViewProps, any> {

	@observable
	selectesClientId: number;

	handleOnChangeSelectedRows = (selectedRowKeys: string[]): void => {
		let client = this.props.model.items.find(x => selectedRowKeys[0] == x.id.toString());
		if (client)
			this.selectesClientId = client.id;
	};

	render() {
		const model = this.props.model;
		const items = model.items.map(o => o);
		const columns: Column[] = [
			{
				key: 'displayName',
				title: 'Name',
				dataIndex: 'displayName',
				filter: {
					field: 'displayName',
					type: 'string',
					render: (value, onChange) => (
						<TextView
							mode="edit"
							label={null}
							value={value}
							onChanged={onChange}
						/>
					)
				},
				render: (text, record: ClientGDPRSummary) => <Link to={`/crm/clients/${record.id}`}>{text}</Link>,
			},
			{
				key: 'email',
				title: 'Email',
				dataIndex: 'email',
				filter: {
					field: 'email',
					type: 'string',
					render: (value, onChange) => (
						<TextView
							mode="edit"
							label={null}
							value={value}
							onChanged={onChange}
						/>
					)
				}
			},
			{
				key: 'birthDate',
				title: 'BirthDate',
				dataIndex: 'birthDate',
				render: (text: any, record: ClientGDPRSummary, index: number) => {
					return <span>{this.props.formatService.toString('short-date', record.birthDate)}</span>;
				},
				filter: {
					field: 'birthDate',
					type: 'date',
					render: (value, onChange) => (
						<DateView
							mode="edit"
							label={null}
							value={value}
							onChanged={(newValue) => {
								if (newValue) {
									let value = this.props.formatService.toString('short-date', newValue);
									onChange(newValue.toISOString());
								} else {
									onChange(null);
								}
							}}
							format="small-date"
						/>
					)
				}
			},
			{
				key: 'contacts',
				title: 'Contacts',
				dataIndex: 'contacts',
				render: (text: any, record: ClientGDPRSummary, index: number) => {
					let contacts = [];

					record.contacts.forEach(c => {
						contacts.push(<Row key={uuid.v4()}>{c.address}</Row>);
					});
					return (
						<React.Fragment>
							{contacts}
						</React.Fragment>
					);
				},
				filter: {
					field: 'postCode',
					type: 'string',
					render: (value, onChange) => (
						<TextView
							mode="edit"
							label={null}
							value={value}
							onChanged={onChange}
						/>
					)
				}
			},
		];
		let selectedRowKeys = [];
		let client = this.props.model.items.find(x => x.id == this.selectesClientId);
		if (client)
			selectedRowKeys.push(client.id.toString());
		return (
			<div className="window window-normal">
				<div className="panel">
					<DataTableView
						applyParamsFilter={['email', 'birthDate', 'postCode']}
						setBusy={this.props.setBusy}
						rowKey={(record) => record.id.toString()}
						columns={columns}
						mode="display"
						model={model}
						hideToolbar={ToolbarVisibility.hideModifyButtons}
						selection={{
							type: 'radio',
							selectedRowKeys,
							onChange: this.handleOnChangeSelectedRows

						}}
						toolbarLeftItems={<div className='ml-3 toolbar-select'>
							<Button
								icon='edit'
								disabled={this.selectesClientId == null}
								onClick={() => this.props.onItemEdit(this.selectesClientId)}
							>
								Client Details
								</Button>
						</div>}
					/>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/gdpr/clients/list/client-gdpr-list.view.tsx